import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { syncSessionUser } from "../utils/sessionUser";

const TopUp = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    let ignore = false;

    const bootstrapWallet = async () => {
      if (!token) {
        navigate("/wallet", { replace: true });
        return;
      }

      localStorage.setItem("token", token);

      try {
        await syncSessionUser(token);
      } catch (error) {
        if (!ignore) {
          toast.error(
            error?.message || "Unable to verify your wallet access link."
          );
        }
      } finally {
        if (!ignore) {
          navigate("/wallet", {
            replace: true,
            state: { initialTab: "topup" },
          });
        }
      }
    };

    void bootstrapWallet();

    return () => {
      ignore = true;
    };
  }, [navigate, token]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gradient-to-b from-[#fff9e8] to-[#fff4d7]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-14 w-14 animate-spin rounded-full border-4 border-amber-200 border-t-orange-500" />
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-500">
          Opening wallet
        </p>
      </div>
    </div>
  );
};

export default TopUp;
